'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventAttributeStore = function () {
    function EventAttributeStore() {
        _classCallCheck(this, EventAttributeStore);

        this.windowWidth = null;
        this.windowHeight = null;
        this.scrollY = null;
        this.overflowScrollY = null;
        this.isPopState = null;
    }

    _createClass(EventAttributeStore, [{
        key: 'getCurrentWindowWidth',
        value: function getCurrentWindowWidth() {
            if (typeof window === 'undefined') {
                return null;
            }

            return this.windowWidth === null ? window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth : this.windowWidth;
        }
    }, {
        key: 'getCurrentWindowHeight',
        value: function getCurrentWindowHeight() {
            return this.windowHeight === null ? window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight : this.windowHeight;
        }
    }, {
        key: 'getCurrentScrollY',
        value: function getCurrentScrollY() {
            if (typeof window === 'undefined') {
                return null;
            }

            return this.scrollY === null ? window.scrollY || window.pageYOffset || document.documentElement.scrollTop : this.scrollY;
        }
    }, {
        key: 'getOverflowScrollY',
        value: function getOverflowScrollY() {
            if (typeof window === 'undefined') {
                return null;
            }

            return this.overflowScrollY;
        }
    }]);

    return EventAttributeStore;
}();

var singleton = new EventAttributeStore();
exports.default = singleton;